<template>
  <div>
    <LeftSidebar
      :visible="visible"
      baseClass="add-term-wrapper"
      :title="$lang.newAccess"
      :hasHeaderRightIcon="false"
    >
      <template>
        <div class="padding-16" v-if="visible">
          <Dropdown
            :title="$lang.selectParvandeh"
            :label="$lang.parvandeh"
            :placeholder="$lang.parvandeh"
            :value="form.parvandeh"
            name="parvandeh"
            id="parvandeh"
            :vuelidateObj="$v.form.parvandeh"
            :asyncSearch="getParvandehCombo"
            :insideFeature="true"
            @input="input"
            @focus="resetValidation"
            @blur="checkValidation"
          />
          <Dropdown
            :title="$lang.selectCenterExecute"
            :label="$lang.centerExecute"
            :placeholder="$lang.centerExecute"
            :value="form.centerExecute"
            name="centerExecute"
            id="centerExecute"
            :vuelidateObj="$v.form.centerExecute"
            :asyncSearch="getCenterExecuteCombo"
            :insideFeature="true"
            @input="input"
            @focus="resetValidation"
            @blur="checkValidation"
          />
        </div>
      </template>
      <template #footer>
        <Button
          variant="filled-complementary"
          :text="$lang.cancel"
          class="mobile-width-percent-100 tablet-width-percent-100"
          contentClass="justify-content-center"
          @click="handleClose"
        />
        <Button
          v-if="checkPermission(permissions, ['admin', 'edit'])"
          variant="primary"
          :text="$lang.submit"
          class="mobile-width-percent-100 tablet-width-percent-100"
          contentClass="justify-content-center"
          :loading="loading"
          @click="handleSubmit"
        />
      </template>
    </LeftSidebar>
  </div>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import LeftSidebar from "@/components/re-design/sidebar/LeftSidebar.vue";
import { Dropdown, Button } from "@/components/re-design/forms";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { checkPermission, generateError, toastAlert } from "@/shared/utils";
import { getParvandehCombo, getCenterExecuteCombo } from "@/services";
import { addCenterExecuteAccess } from "@/modules/kanoon/services";

export default {
  mixins: [inputMixin],
  inject: ["reloadList"],
  components: { LeftSidebar, Dropdown, Button },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    permissions: {
      type: Array,
      default: () => [],
    },
  },
  validations() {
    return {
      form: {
        parvandeh: { required },
        centerExecute: { required },
      },
    };
  },
  data() {
    return {
      form: {
        parvandeh: null,
        centerExecute: null,
      },
      loading: false,
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(value) {
        if (value) {
          // reset all field of form (this method imported of input mixin)
          this.resetForm();
        }
      },
    },
  },
  methods: {
    checkPermission,
    getParvandehCombo,
    getCenterExecuteCombo,
    handleClose() {
      this.$emit("handleClose");
    },
    handleReloadList() {
      this.$emit("handleReloadList");
    },
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.loading = true;
        const parvandehCode = pathOr(null, ["parvandeh", "id"], this.form);
        const centerExecuteCode = pathOr(
          null,
          ["centerExecute", "id"],
          this.form
        );

        const response = await addCenterExecuteAccess(
          parvandehCode,
          centerExecuteCode
        );
        const { message } = response;
        toastAlert(message);
        this.handleClose();
        this.handleReloadList();
      } catch (error) {
        generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
